<template>
  <v-container fluid mx-0 pa-0>
    <v-row v-if="L_LoadIndice < L_LoadLimit"> {{ T_Message }} {{ L_LoadIndice }} / {{ L_LoadLimit }} </v-row>
    <v-row v-else-if="T_Message != ''">
      {{ T_Message }}
    </v-row>

    <v-row style="max-width: 98%; margin: 0px auto">
      <div class="my-4" style="font-size: 1.2em">Liste des Autorisations</div>
      <v-spacer />
      <v-text-field v-model="T_Search" append-icon="mdi-magnify" label="Rechercher" single-line hide-details class="mr-4"></v-text-field>
    </v-row>
    <v-data-table v-model="TO_SelectedLines" :headers="TO_Headers" :items="TO_Datalines" :single-select="B_SingleSelect" :items-per-page="10" show-select :search="T_Search">
      <template #item.search_ca="{ item }">
        <div>
          {{ item.libelle_ca }} <span style="color: #aaa">({{ item.code_ca }})</span>
        </div>
      </template>

      <template #item.search_na="{ item }">
        <div>
          {{ item.libelle_na }} <span style="color: #aaa">({{ item.code_na }})</span>
        </div>
      </template>

      <template #item.user_engagement="{ item }">
        <div>
          <v-autocomplete
            v-model="item.user_engagement"
            multiple
            :items="TO_UserList"
            label="Utilisateurs"
            item-text="email"
            item-value="id"
            chips
            @blur="Fct_SelectUserEngage(item.id, item.user_engagement)"
          ></v-autocomplete>
        </div>
      </template>

      <template #item.user_approbation="{ item }">
        <div>
          <v-autocomplete
            v-model="item.user_approbation"
            multiple
            :items="TO_UserList"
            label="Utilisateurs"
            item-text="email"
            item-value="id"
            chips
            @blur="Fct_SelectUserApprob(item.id, item.user_approbation)"
          ></v-autocomplete>
        </div>
      </template>
    </v-data-table>
    <v-row style="max-width: 98%; margin: 0px auto">
      <v-col sm="7" md="6" lg="4">
        <v-autocomplete
          v-model="TO_SelectedUsers"
          multiple
          chips
          class="mb-2"
          :items="TO_UserList"
          item-text="email"
          item-value="id"
          label="Ajouter à la sélection"
        ></v-autocomplete>
        <v-row>
          <v-btn :disabled="selEmpty || !selHasUsers" color="secondary" title="Donner la permission d'engagement à ces utilisateurs" @click="Fct_AddUserEngage">
            + Engagement
          </v-btn>
          <v-btn :disabled="selEmpty || !selHasUsers" color="secondary" title="Donner la permission d'approbation à ces utilisateurs" class="ml-4" @click="Fct_AddUserApprob">
            + Approbation
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Autorisations",
  data: () => ({
    T_Message: "",
    T_Period: "",
    T_AnalyticalAccountCode: "",
    B_SingleSelect: false,
    TO_SelectedLines: [],
    TO_Headers: [
      { text: "Compte analytique", value: "search_ca", align: "left", sortable: false },
      { text: "Nature analytique", value: "search_na" },
      { text: "Utilisateur engagement", value: "user_engagement" },
      { text: "Utilisateur approbation", value: "user_approbation" }
    ],
    TO_Datalines: [],
    TO_Autorisations: [],
    TO_Budgets: [],
    TO_UserList: [],
    TO_SelectedUsers: [],
    T_Search: "",
    TB_Loaded: [],
    B_Loaded: false,
    L_LoadIndice: 0,
    L_LoadLimit: 0
  }),
  created() {
    this.T_Period = this.$cookies.get("Period");
    this.T_AnalyticalAccountCode = this.$cookies.get("AnalyticalAccountCode");
    this.TB_Loaded["Autorisation"] = false;
    this.TB_Loaded["Budget"] = false;
    this.TB_Loaded["FillTable"] = false;
    this.Fct_Loading();
    this.Fct_GetAutorisation();
  },
  computed: {
    selEmpty() {
      return this.TO_SelectedLines.length <= 0;
    },
    selHasUsers() {
      return this.TO_SelectedUsers.length > 0;
    }
  },
  methods: {
    Fct_Loading() {
      // vérifie l'avancement du chargement de la page
      if (!this.TB_Loaded["Autorisation"]) {
        this.T_Message = "Chargement des autorisations";
      } else if (!this.TB_Loaded["Budget"]) {
        this.T_Message = "Chargement des budgets";
      } else if (!this.TB_Loaded["User"]) {
        this.T_Message = "Chargement des utilisateurs";
      } else if (!this.TB_Loaded["FillTable"]) {
        this.T_Message = "Chargement des données..";
      } else {
        this.B_Loaded = true;
      }

      if (this.B_Loaded) {
        this.T_Message = "";
      } else {
        setTimeout(this.Fct_Loading, 500);
      }
    },
    Fct_GetAutorisation() {
      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      this.$BackEndAPI
        .get("autorisation/", { headers: { Authorization: T_Token } })
        .then(response => {
          this.TO_Autorisations = response.data;
          this.TB_Loaded["Autorisation"] = true;
          this.Fct_GetBudgets();
        })
        .catch(() => {
          this.$router.push({ name: "Disconnect" });
        });
    },
    Fct_GetBudgets() {
      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      this.$BackEndAPI
        .get("budget/", { headers: { Authorization: T_Token } })
        .then(response => {
          this.TO_Budgets = response.data;
          this.TB_Loaded["Budget"] = true;
          this.Fct_GetUsers();
        })
        .catch(() => {
          this.$router.push({ name: "Disconnect" });
        });
    },
    Fct_GetUsers() {
      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      this.$BackEndAPI
        .get("user/", { headers: { Authorization: T_Token } })
        .then(response => {
          this.TO_UserList = response.data;
          this.TB_Loaded["User"] = true;
          this.Fct_FillTable();
        })
        .catch(() => {
          this.$router.push({ name: "Disconnect" });
        });
    },
    Fct_FillTable() {
      //rechercher parmi les autorisations celles qui correspondent à la période
      this.L_LoadIndice = 0;
      this.L_LoadLimit = this.TO_Budgets.length;

      this.TO_Datalines = [];
      for (var i = 0; i < this.L_LoadLimit; i++) {
        //if(this.TO_Budgets[i].periode == this.T_Period)
        if (this.TO_Budgets[i].periode.substring(0, 2) == this.T_Period) {
          if (this.T_AnalyticalAccountCode == "" || this.T_AnalyticalAccountCode == "all" || this.T_AnalyticalAccountCode == this.TO_Budgets[i].cpteAnalytique) {
            var TO_UserEngage = new Array();
            var TO_UserApprob = new Array();

            for (var j = 0; j < this.TO_Autorisations.length; j++) {
              if (this.TO_Autorisations[j].fk_Budget == this.TO_Budgets[i].id) {
                if (this.TO_Autorisations[j].type == 1) {
                  TO_UserEngage.push(this.TO_Autorisations[j].fk_User);
                }
                if (this.TO_Autorisations[j].type == 2) {
                  TO_UserApprob.push(this.TO_Autorisations[j].fk_User);
                }
              }
            }

            var O_Budgets = {};
            O_Budgets.id = this.TO_Budgets[i].id;
            O_Budgets.code_ca = this.TO_Budgets[i].cpteAnalytique;
            O_Budgets.code_na = this.TO_Budgets[i].natureAnalytique;
            O_Budgets.libelle_ca = this.TO_Budgets[i].libelle_CA;
            O_Budgets.libelle_na = this.TO_Budgets[i].libelle_nature;
            O_Budgets.search_ca = O_Budgets.code_ca + " " + O_Budgets.libelle_ca;
            O_Budgets.search_na = O_Budgets.code_na + " " + O_Budgets.libelle_na;
            O_Budgets.user_engagement = TO_UserEngage;
            O_Budgets.user_approbation = TO_UserApprob;
            this.TO_Datalines.push(O_Budgets);
          }
        }

        this.L_LoadIndice += 1;
      }

      this.TB_Loaded["FillTable"] = true;
    },
    Fct_SelectUserEngage(L_ID, TL_UsersSelected) {
      let formData = new FormData();
      formData.append("type_autorisation", 1);
      formData.append("id_budget", L_ID);

      for (var j = 0; j < TL_UsersSelected.length; j++) {
        formData.append("id_users", TL_UsersSelected[j]);
      }

      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      this.$BackEndAPI
        .post("autorisation/updateautorisation/", formData, { headers: { Authorization: T_Token } })
        .then(function() {})
        .catch(error => {
          alert("Erreur (004) - " + error);
        });
    },
    Fct_SelectUserApprob(L_ID, TL_UsersSelected) {
      let formData = new FormData();
      formData.append("type_autorisation", 2);
      formData.append("id_budget", L_ID);

      for (var j = 0; j < TL_UsersSelected.length; j++) {
        formData.append("id_users", TL_UsersSelected[j]);
      }

      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      this.$BackEndAPI
        .post("autorisation/updateautorisation/", formData, { headers: { Authorization: T_Token } })
        .then(function() {})
        .catch(error => {
          alert("Erreur (004) - " + error);
        });
    },
    Fct_AddUserEngage() {
      var TO_Selection = [];

      for (var L_Index = 0; L_Index < this.TO_SelectedLines.length; L_Index++) {
        var O_SelectedLine = this.TO_SelectedLines[L_Index];
        var O_Select = {};
        O_Select.idbudget = O_SelectedLine.id;
        O_Select.type = 1;
        O_Select.iduser = this.TO_SelectedUsers;
        TO_Selection.push(O_Select);
      }

      if (TO_Selection.length == 0) {
        alert("Veuillez sélectionner au moins une ligne pour y attribuer des utilisateurs");
      } else if (this.TO_SelectedUsers.length == 0) {
        alert("Veuillez sélectionner au moins un utilisateur");
      } else {
        let TO_FormData = new FormData();
        TO_FormData.append("selection", JSON.stringify(TO_Selection));

        var T_Token = "JWT " + this.$cookies.get("BackEndToken");
        this.$BackEndAPI
          .post("autorisation/updatelist/", TO_FormData, { headers: { Authorization: T_Token } })
          .then(() => {
            this.TB_Loaded["Autorisation"] = false;
            this.TB_Loaded["Budget"] = false;
            this.TB_Loaded["FillTable"] = false;
            this.Fct_Loading();
            this.Fct_GetAutorisation();
          })
          .catch(() => {
            this.$router.push({ name: "Disconnect" });
          });
      }
    },
    Fct_AddUserApprob() {
      var TO_Selection = [];

      for (var L_Index = 0; L_Index < this.TO_SelectedLines.length; L_Index++) {
        var O_SelectedLine = this.TO_SelectedLines[L_Index];
        var O_Select = {};
        O_Select.idbudget = O_SelectedLine.id;
        O_Select.type = 2;
        O_Select.iduser = this.TO_SelectedUsers;
        TO_Selection.push(O_Select);
      }

      if (TO_Selection.length == 0) {
        alert("Veuillez sélectionner au moins une ligne pour y attribuer des utilisateurs");
      } else if (this.TO_SelectedUsers.length == 0) {
        alert("Veuillez sélectionner au moins un utilisateur");
      } else {
        let TO_FormData = new FormData();
        TO_FormData.append("selection", JSON.stringify(TO_Selection));

        var T_Token = "JWT " + this.$cookies.get("BackEndToken");
        this.$BackEndAPI
          .post("autorisation/updatelist/", TO_FormData, { headers: { Authorization: T_Token } })
          .then(() => {
            this.TB_Loaded["Autorisation"] = false;
            this.TB_Loaded["Budget"] = false;
            this.TB_Loaded["FillTable"] = false;
            this.Fct_Loading();
            this.Fct_GetAutorisation();
          })
          .catch(() => {
            this.$router.push({ name: "Disconnect" });
          });
      }
    }
  }
};
</script>

<style scoped></style>
